/** Reads the claims of a JWT without validating it; the API validates the signature on every request. */
export function decodeJwtClaims(token: string | null | undefined): Record<string, unknown> {
    const payload = token?.split('.')[1];
    if (!payload) return {};
    try {
        const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
        const bytes = Uint8Array.from(atob(base64), character => character.charCodeAt(0));
        const claims: unknown = JSON.parse(new TextDecoder().decode(bytes));
        return claims !== null && typeof claims === 'object' && !Array.isArray(claims) ? claims as Record<string, unknown> : {};
    } catch {
        return {};
    }
}
